module.exports = __webpack_public_path__ + "static/media/V.7364f7e0.gif";